// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MobileWithValidation-module__buttonContainer___3HX3b{padding-top:20px}.MobileWithValidation-module__linkContainer___3Q_5Q{padding-top:40px}", ""]);
// Exports
exports.locals = {
	"buttonContainer": "MobileWithValidation-module__buttonContainer___3HX3b",
	"linkContainer": "MobileWithValidation-module__linkContainer___3Q_5Q"
};
module.exports = exports;
